import React, { useState } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import {
    Backdrop,
    CircularProgress,
    Paper,
    Typography,
} from '@material-ui/core';
import useStyles from '../styles/styles';
import {Alert} from '@material-ui/lab';
import AdvertiserTable from '../components/Advertiser/AdvertiserTable';

const Advertiser = () => {
    const classes = useStyles();
    const [success, setSuccess] = useState(false);
    
    const {loading, error, data, refetch} = useQuery(gql`
        query AllAdvertiser {
            allAdvertiser {
                id
                companyId
                key
                isTest
                maskedName
                name
            }
            allCompanies {
                id
                name
            }
            allOffer {
                advertiserId
                offerId
                offerName
                offerUrls {
                    offerUrlId
                    url
                }
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
        context: {
            clientName: "kgraphql"
        }
    });

    const {loading: offersLoading, error: offersError, data: offersData, refetch: offersRefetch} = useQuery(gql`
        query AllOffer {
            allOffer {
                advertiserId
                offerId
                offerName
                offerUrls {
                    offerUrlId
                    url
                }
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
        context: {
            clientName: "kgraphql"
        }
    });

    const [createAdvertiser, {loading: createAdvertiserLoading}] = useMutation(gql`
        mutation createAdvertiser($input: AdvertiserMutatorInput!) {
            createAdvertiser(input: $input) {
                id
                companyId
                key
                isTest
                maskedName
                name
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });
    
    if (loading || createAdvertiserLoading || offersLoading) {
        return (
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
    }

    return (
        <>
            <Typography variant="h2">
                Advertisers
            </Typography>
            {!loading && !offersLoading && error ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </Paper>
            ) : null}
              {!loading && !offersLoading && Object.keys(data).length ? (
                <AdvertiserTable
                    data={{...data, ...offersData}}
                    refetch={() => {refetch(); offersRefetch();}}
                    setSuccess={setSuccess}
                    createAdvertiser={createAdvertiser}
                    createAdvertiserLoading={createAdvertiserLoading}
                />
            ) : null}
        </>
    )
};

export default Advertiser;